import LocalizedStrings from "react-localization";
import localizations from "../localization";
import {useLanguage} from "../contexts/LanguageProvider";

export default function useQuarters() {
  const {language} = useLanguage();
  let translation = new LocalizedStrings(localizations);
  translation.setLanguage(language);
  return [
    translation.quarter1,
    translation.quarter2,
    translation.quarter3,
    translation.quarter4
  ];
}
